/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/13/20
 * Time: 8:51 AM
 */
import React from 'react';
import {Modal} from "semantic-ui-react";
import './PaymentModal.scss'
import * as commonFunc from "../../../utils/commonFunc";
import Files from "react-files";
import * as actionModalCreator from "../../../store/domain/modal/action";
import {connect} from "react-redux";
import {Button, Col, Row} from "reactstrap";
import MonthSelector from "../../MonthPicker/MonthSelector";
import {withRouter} from "react-router";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as constants from '../../../const/constants';
import {lang, language} from "../../../const/language";
import * as dropdownConst from "../../../utils/dropdownConst";

class App extends React.Component{
    state = {depSlip:'',type:"",isSelectMonth: false, status:''};

    onFilesChange = async files => {
        if (files.length !== 0) {
            let file = files[0];
            const imageDataUrl = await commonFunc.readFile(file);
            this.setState({
                type:file.type,
                depSlip: imageDataUrl
            });
        }
    };

    purchaseHandler = (status) => {
        let {isPaymentObj} = this.props;
        if (isPaymentObj.classId === undefined && isPaymentObj.lessonId !== undefined) {
            let {depSlip} = this.state;
            let obj = {
                classId: isPaymentObj.classId,
                lessonId: isPaymentObj.lessonId,
                status:status,
                imageUrl: status === constants.SLIP_TYPE ? depSlip: undefined
            };
            commonFunc.studentPurchaseWarning(this.props, obj);
        } else {
            let months = dropdownConst.months;
            let curMonth = new Date().getMonth();
            let curYear = new Date().getFullYear();

            this.timer = setTimeout(()=>{
                this.selectMonthHandler({month:months[curMonth].value, year: curYear},status)
            }, 100);
            // this.setState({isSelectMonth:true,status: status})
        }
    };
    closeMonthHandler = () => {
        this.setState({isSelectMonth:false})
    };
    selectMonthHandler = (month,st) => {
        let {isPaymentObj} = this.props;
        let {status,depSlip} = this.state;
        if(st){
            status = st;
        }

        let obj = {...month, classId: isPaymentObj.classId, status:status, imageUrl: status === constants.SLIP_TYPE ? depSlip: undefined };
        commonFunc.studentPurchaseWarning(this.props, obj);
    };
    componentWillUnmount(){
        clearTimeout(this.timer)
    }

    render() {
        let {depSlip,type,isSelectMonth} = this.state;
        return (
            <Modal size={"tiny"} open={true} centered={true}
                   className={"payment-modal"}>
                <Modal.Header>
                    <div className={"header-wrapper"}>
                        <p>{`${!isSelectMonth ? language[lang].SelectPaymentType : language[lang].SelectPaymentMonth }`}</p>
                        <i className="fa fa-close" aria-hidden="true" onClick={() => this.props.setPaymentModal(false)}/>
                    </div>
                </Modal.Header>

                <Modal.Content>
                    <Row>
                        <Col xs={12} className={"card-section"}>
                            <div className={"align-left"}>
                                <Button className="log-btn com-btn"
                                        onClick={()=>this.purchaseHandler(constants.CARD_TYPE)}>
                                    {language[lang].PayByCard}
                                </Button>
                            </div>
                            {/*<div className={"payment-note-wrapper"}>*/}
                            {/*    <p>*/}
                            {/*        {language[lang].cardPayment}*/}
                            {/*    </p>*/}
                            {/*</div>*/}


                        </Col>
                        <Col xs={12} className={"or-section"}>
                            <p>- {language[lang].OrText} -</p>
                        </Col>
                        <Col xs={12} className={"slip-section"}>
                            <label>{language[lang].ChooseBankDepositSlip}</label>
                            <div className={"files-wrapper"}>
                                <Files
                                    className='files-dropzone-file'
                                    onChange={this.onFilesChange}
                                    accepts={["image/png", "image/jpg", "image/jpeg"]}
                                    multiple={false}
                                    maxFileSize={10485760}
                                    minFileSize={0}
                                    onError={commonFunc.onFileError}
                                    clickable
                                >
                                    <div className="file-wrapper">
                                        <p className="file-text">
                                            {language[lang].DragHereText} {depSlip !== '' ? <span> | <span className={"a-link"} onClick={()=>commonFunc.getB64ToBlob(depSlip,type)}>{language[lang].ViewSlip}</span> </span>: null}</p>
                                        {/*<span className={"a-link"}>{language[lang].BrowseHereText}</span>*/}
                                    </div>
                                </Files>
                            </div>

                            {
                                depSlip !== "" &&
                                <div className={"align-right mt-2"}>
                                    <Button className="reg-btn com-btn"
                                            onClick={()=>this.purchaseHandler(constants.SLIP_TYPE)} disabled={depSlip === ""}>
                                        {language[lang].SumbitDepositSlip}
                                    </Button>
                                </div>
                            }


                            <div className={"bank-details"}>
                                <p><label>Bank</label>: BOC</p>
                                <p><label>Name</label>: H.C kankanamge</p>
                                <p><label>Acc No</label>: 85835544</p>
                                <p><label>Branch</label>: Matara</p>
                            </div>
                            <div className={"payment-note-wrapper"}>
                                {/*<p className={"bold-text"}>{language[lang].paymentNote}:</p>*/}
                                {/*<p>{language[lang].paymentNoteDesc}</p>*/}
                                <p>
                                    <span className={"bold-text"}>{language[lang].paymentNote}: </span>
                                    {language[lang].paymentNoteDesc}
                                </p>
                                <p className={"bold-text"}>{language[lang].paymentNoteMore}</p>
                            </div>

                        </Col>
                        {isSelectMonth &&
                        <MonthSelector selectMonthHandler={this.selectMonthHandler}
                                       closeMonthHandler={this.closeMonthHandler}/>}
                    </Row>

                </Modal.Content>
            </Modal>
        );
    }
}
const mapStateToProps = (state) => ({
    isPaymentObj: state.modal.isPaymentObj,
    userType: state.auth.userType,
});
const mapDispatchToProps = (dispatch) => ({
    setPaymentModal: data => dispatch(actionModalCreator.setPaymentModal(data)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
